module.exports = __webpack_public_path__ + "static/media/disruptionWOwatermark_6.220115c9.jpg";